import { render, staticRenderFns } from "./AddressPerson.vue?vue&type=template&id=6511a459"
import script from "./AddressPerson.vue?vue&type=script&lang=js"
export * from "./AddressPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports